<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="15">
          <el-input style="width:200px;"
                    placeholder="请输入手机号"
                    prefix-icon="el-icon-search"
                    v-model="linkmantel">
          </el-input>
          <el-input style="width:200px;"
                    placeholder="请输入姓名"
                    prefix-icon="el-icon-search"
                    v-model="linkman">
          </el-input>
          <el-select v-model="status" placeholder="状态" style="width:100px">
          <el-option
           v-for="item in auditArr"
           :key="item.value"
           :label="item.label"
           :value="item.value">
          </el-option>
          </el-select>
        </el-col>
        <ReasonDialog ref="ReasonEdit" @bindGrid="bindGrid"></ReasonDialog>
        <el-button type="primary" icon="el-icon-search" @click="bindGrid">搜索</el-button>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="thistableHeight()"
      size="mini"
      stripe
      border
      v-show="status1"
      style="width: 100%;">
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="applybydname"
        label="门店"  width="120"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="handleoverdate"
        label="成交日期"
        header-align="center"
        align="left"
        width="150">
      </el-table-column>
      <el-table-column
        prop="linkman"
        label="姓名"  width="90"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="linkmantel"
        label="手机号"  width="120"
        align="left" header-align="center">
      </el-table-column>
      <el-table-column
        prop="erpserial"
        label="订单号" width="100"
        align="left" header-align="center">
      </el-table-column>
      <el-table-column
        prop="seedlist"
        label="商品"
        align="left" header-align="center">
        <template slot-scope="scope">
          <span v-html="getGoods(scope.row.seedlist)"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row,$event)">回访
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table
      :data="tableData"
      :height="thistableHeight()"
      size="mini"
      stripe
      border
      v-show="status2"
      style="width: 100%;"

    >
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="dname"
        label="门店"  width="120"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="auditdate"
        label="回访日期"
        header-align="center"
        align="left"
        width="150">
      </el-table-column>
      <el-table-column
        prop="audituname"
        label="回访人"  width="90"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="uname"
        label="客户"  width="90"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="uguid"
        label="手机号"  width="120"
        align="left" header-align="center">
      </el-table-column>
      <el-table-column
        prop="components"
        label="订单号" width="100"
        align="left" header-align="center">
      </el-table-column>
      <el-table-column
        prop="yecontent" :show-overflow-tooltip="true"
        label="反馈"
        align="left" header-align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="120" >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleView(scope.$index, scope.row,$event)">查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
  </div>
</template>
<script>
  import ReasonDialog from './ReasonDialog';
  import {getListData, removeData, pass, registerApi} from '@/api/workflow/waitaudit';
  import {getListData as deptList} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';

  export default {
    name: 'waitauditlist',
    data() {
      return {
        dialogVisible: false,
        auditArr:[{value:9,label:'待回访'},{value:8,label:'回访日志'}],
        linkman: '',
        linkmantel: '',
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        status1: true,
        status2: false,
        idd: [],
        servedserial: '',
        servedname: '',
        serveuguid: '',//业务员ID
        serveuname: '',//业务员名称
        status:9,
      }
    },
    props: {
      auditstatus: {
        default: ""
      }
    },
    methods: {
      getGoods(seedlist) {
        var sl = JSON.parse(seedlist);
        var goodsname = '';
        for (let i in sl) {
          if (goodsname.indexOf(sl[i].seedname) > -1) continue;

          if (goodsname != '')
            goodsname += "<br>";

          goodsname += sl[i].seedname;
        }
        return goodsname;
      },
      thistableHeight() {
        return this.tableHeight(116);
      },
      //跳转编辑页面
      handleEdit(index, row, event) {
        this.$refs.ReasonEdit.show(row);
      },
      handleView(index, row, event) {
        this.$refs.ReasonEdit.showView(row);
      },
      //绑定分页参数
      bindGrid() {
        if (this.status == 9) {
          this.status1 = true;
          this.status2 = false;
        } else {
          this.status1 = false;
          this.status2 = true;
        }
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          linkmantel: this.linkmantel,
          linkman: this.linkman,
          status: this.status
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        })
      },
    },

    mounted() {
      this.bindGrid();
    },
    components: {
      ReasonDialog
    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/waitauditList.vue